export default __webpack_public_path__ + "static/dummyThree-3571a6f7c1ba48f6078a324096ebd24b.png";